import { Accordion, CloseButton } from '@any-ui-react/core';
import classNames from 'classnames';

import { SettingGuideContent } from './SettingGuideContent';
import { SettingGuideHeader } from './SettingGuideHeader';
import { SettingGuideProps, useSettingGuideItems } from './useSettingGuideItems';

export const SettingGuide = ({
  wrapperClassName,
  hasSalesChannels,
  hasShopifyChannel,
  hasDatasourcesChannels,
  hasInputUnitCost,
  hasInputSaleChannelCostIndex,
  hideSettingGuide,
}: SettingGuideProps & {
  wrapperClassName: string;
  hideSettingGuide: () => void;
}) => {
  const { settingGuideItems } = useSettingGuideItems({
    hasSalesChannels,
    hasShopifyChannel,
    hasDatasourcesChannels,
    hasInputUnitCost,
    hasInputSaleChannelCostIndex,
  });

  const checkedItems = settingGuideItems.filter((item) => item.isChecked).length;

  const progressPercentage =
    settingGuideItems.length === checkedItems
      ? 100
      : Math.round(100 / settingGuideItems.length) * checkedItems;

  return (
    <div className={classNames('card mb-4', wrapperClassName)}>
      <Accordion defaultValue="setting-guide" className="relative">
        <Accordion.Item value="setting-guide" className="rounded-sm border-0">
          <Accordion.Control
            classNames={{
              control: 'w-full pr-12 pl-3',
              label: 'py-3 pr-0 pl-1 text-sm',
              chevron: 'mr-1 ml-2',
            }}
          >
            <SettingGuideHeader progressPercentage={progressPercentage} />
          </Accordion.Control>
          <Accordion.Panel classNames={{ content: 'p-0' }}>
            <SettingGuideContent items={settingGuideItems} />
          </Accordion.Panel>
          <CloseButton className="absolute top-5 right-4" onClick={hideSettingGuide} />
        </Accordion.Item>
      </Accordion>
    </div>
  );
};
